import { render, staticRenderFns } from "./wtAddWallpaper.component.vue?vue&type=template&id=9a2f2ca4&"
import script from "./wtAddWallpaper.component.vue?vue&type=script&lang=js&"
export * from "./wtAddWallpaper.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports